import React from "react"

export default function TableOfContentsSection({ children, className }) {
  return (
    <div className={`${className} mb-4 text-xl text-gray-800 leading-tight`}>
      {children}
    </div>
  )
}
